import EditableDropdownExample from "./examples/EditableDropdown.Example";
import EditableDropdownFreeformExample from "./examples/EditableDropdownFreeform.Example";

export default [
    {
        title: "Editable dropdown",
        component: EditableDropdownExample,
        code: require("!raw-loader!./examples/EditableDropdown.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    },
    {
        title: "Freeform editable dropdown",
        component: EditableDropdownFreeformExample,
        code: require("!raw-loader!./examples/EditableDropdownFreeform.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    }
];
